import { useState } from 'react';
import { Check, ChevronsUpDown, Search } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from '../ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

/**
 * Searchable supplier picker for the Portal Collector.
 * suppliers: [{ supplierName, supplierShortName }]
 * value: selected supplierShortName
 * onChange(shortName, displayName)
 */
export const SupplierCombobox = ({ suppliers = [], value, onChange, disabled, testId = 'collector-supplier-combobox' }) => {
  const [open, setOpen] = useState(false);
  const selected = suppliers.find((s) => s.supplierShortName === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className="w-full justify-between rounded-none mt-1 font-normal"
          data-testid={testId}
        >
          <span className={selected ? '' : 'text-muted-foreground'}>
            {selected ? selected.supplierName : 'Select supplier…'}
          </span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 rounded-none" align="start">
        <Command>
          <div className="flex items-center border-b px-3">
            <Search className="h-4 w-4 shrink-0 opacity-50" />
            <CommandInput placeholder="Search supplier…" className="border-0 focus:ring-0" data-testid="collector-supplier-search" />
          </div>
          <CommandList className="max-h-64">
            <CommandEmpty>No supplier found.</CommandEmpty>
            <CommandGroup>
              {suppliers.map((s) => (
                <CommandItem
                  key={s.supplierShortName}
                  value={`${s.supplierName} ${s.supplierShortName}`}
                  onSelect={() => { onChange(s.supplierShortName, s.supplierName); setOpen(false); }}
                  data-testid={`collector-supplier-option-${s.supplierShortName}`}
                >
                  <Check className={`mr-2 h-4 w-4 ${value === s.supplierShortName ? 'opacity-100' : 'opacity-0'}`} />
                  {s.supplierName}
                  <span className="ml-auto text-xs text-muted-foreground font-mono">{s.supplierShortName}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SupplierCombobox;
